// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pI3Am","tabsBox":"styles_tabsBox__3suEG","createButton":"styles_createButton__2MKb7"};